var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3263 1.90454H21.6998L14.3297 10.328L23 21.7905H16.2112L10.894 14.8386L4.80995 21.7905H1.43443L9.31743 12.7806L1 1.90454H7.96111L12.7674 8.25887L18.3263 1.90454ZM17.1423 19.7713H19.0116L6.94539 3.81767H4.93946L17.1423 19.7713Z",
    fill: "#282B59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.46dbdad2459f2a168b2c923822245197.svg";
export { ForwardRef as ReactComponent };